import React, { Component } from 'react';
import PopupContainer from '../../../components/PopupContainer';
import Popup from '../../../components/SimplePopup';
import { withRouter } from 'react-router-dom';
import { API } from '../../../requests';
import moment from 'moment';

import ViewRenderer from './views';
import Spinner from '../../../components/Spinner';
import { commonImages } from '../../../assets/images';
import strings from '../../../globalization';
import { connect } from 'react-redux';

const POPUP_CONSTANTS = {
  STANDARD: 'standard',
  SIMPLE_POPUP: 'simple',
  ERROR: 'error',
  SPINNER_POPUP: 'spinner',
};

class AgencyRefunds extends Component {
  constructor(props) {
    super(props);
    console.log(props);
    const { reduxProps } = this.props;
    const {
      login: { loginInfo },
    } = reduxProps;
    const { company, user } = loginInfo;
    console.log(user);
    // Set default date range to last 7 days
    const endDate = moment();
    const startDate = moment().subtract(7, 'days');
    const defaultDates = {
      start: startDate.toDate(),
      end: endDate.toDate(),
    };
    this.state = {
      selectedStatus: 'all', // Default status
      searchText: '',
      company,
      user,
      agencyList: [],
      selectedAgency: undefined,
      selectedAgencyOrderList: [],
      startDate: startDate.format('YYYY-MM-DD'),
      endDate: endDate.format('YYYY-MM-DD'),
      dates: defaultDates,
    };
  }

  componentWillMount() {
    this.unlisten = this.props.history.listen((location, action) => {
      this.setState({
        agencies: [],
        filterAgencies: [],
        popup: undefined,
      });

      this.getData();
    });
  }

  componentWillUnmount() {
    this.unlisten();
  }

  componentDidMount() {
    this.setState({
      popup: undefined,
    });
    this.getData();
  }

  getActiveAgencies = () => {
    API.getActiveAgencies()
      .then(agencyList => {
        console.log('active agencies list', agencyList);
        this.setState({
          agencyList: agencyList.data,
          popup: undefined,
        });
      })
      .catch(error => {
        console.log('error fetching active agencies');
        const errorMsg = error.response
          ? error.response.data.message
          : error.message;
        console.info('error....', errorMsg);
        this.setState({
          popup: undefined,
        });
        this.showErrorPopup(
          'There was an error while fetching the agency list, please try again after some time.',
        );
      });
  };

  getOrdersListByAgencies = () => {
    const { selectedAgency, startDate, endDate, selectedStatus } = this.state;
    const { id: selectedAgencyId } = selectedAgency || {};

    if (!selectedAgencyId) {
      this.showErrorPopup('Please select an agency before fetching orders.');
      return;
    }

    // Show loading spinner
    this.setState({
      popup: {
        type: POPUP_CONSTANTS.SPINNER_POPUP,
      },
    });

    // Pass 'all' as undefined to fetch all statuses, or pass the specific status
    const status = selectedStatus === 'all' ? undefined : selectedStatus;

    API.fetchOrdersByAgency(selectedAgencyId, status, startDate, endDate)
      .then(selectedAgencyOrderList => {
        console.log('selectedAgencyOrderList:', selectedAgencyOrderList.data);
        this.setState({
          selectedAgencyOrderList: selectedAgencyOrderList.data,
          popup: undefined,
        });
      })
      .catch(error => {
        console.log('error fetching selectedAgencyOrderList');
        const errorMsg = error.response
          ? error.response.data.message
          : error.message;
        console.info('error....', errorMsg);
        this.setState({
          popup: undefined,
        });
        this.showErrorPopup(
          'There was an error while fetching the order list for the selected agency, please try again after some time.',
        );
      });
  };

  getData = async () => {
    this.setState({
      popup: {
        type: POPUP_CONSTANTS.SPINNER_POPUP,
      },
    });
    this.getActiveAgencies();
  };

  showErrorPopup = errorMessage => {
    this.setState({
      popup: {
        type: POPUP_CONSTANTS.SIMPLE_POPUP,
        message: errorMessage,
        messageStyle: { color: '#E67717' },
        headingImage: commonImages.errorIcon,
        onClose: this.closePopup,
        buttons: [
          {
            text: strings.okayPopup,
            onClick: this.closePopup,
            outline: true,
          },
        ],
      },
    });
  };

  onChangeHandler = (action, data) => {
    switch (action) {
      case 'onSelectAgency': {
        console.info('Selected agency:', data);
        this.setState({
          selectedAgency: data,
        });
        break;
      }

      case 'onStatusChange': {
        console.info('Selected status:', data);
        this.setState({
          selectedStatus: data,
        });
        break;
      }

      case 'date': {
        console.info('Selected date range:', data);
        this.setState({
          startDate: data.startDate,
          endDate: data.endDate,
          dates: data.dates,
        });
        break;
      }

      default: {
        console.info('case not handled', action);
      }
    }
  };

  onClickHandler = (action, data) => {
    const { history, location, status } = this.props;
    console.log('data:', data);

    switch (action) {
      case 'onFetchAgencyOrders': {
        // Fetch orders when button is clicked
        this.getOrdersListByAgencies();
        break;
      }

      case 'rowClick': {
        history.push({
          pathname: '/u/refund-management/orders',
          state: { orderId: data?.orderId },
        });
        break;
      }

      case 'clearFilters': {
        this.resetData();
        break;
      }

      default: {
        console.info('case not handled', action);
      }
    }
  };

  resetData = () => {
    const endDate = moment();
    const startDate = moment().subtract(7, 'days');
    const defaultDates = {
      start: startDate.toDate(),
      end: endDate.toDate(),
    };
    this.setState({
      searchText: '',
      selectedAgency: undefined,
      selectedAgencyOrderList: [],
      selectedStatus: 'all',
      startDate: startDate.format('YYYY-MM-DD'),
      endDate: endDate.format('YYYY-MM-DD'),
      dates: defaultDates,
      popup: undefined,
    });
  };

  closePopup = () => {
    this.setState({
      popup: undefined,
    });
  };

  getProps = () => {
    const { user } = this.state;
    return {
      onClick: this.onClickHandler,
      selectedStatus: this.state.selectedStatus,
      onChange: this.onChangeHandler,
      searchText: this.state.searchText,
      agencyList: this.state.agencyList,
      selectedAgency: this.state.selectedAgency,
      selectedAgencyOrderList: this.state.selectedAgencyOrderList,
      dates: this.state.dates,
      roleId: user.roleId,
    };
  };

  getPopupContent = () => {
    const { popup } = this.state;
    if (!popup) return;
    switch (popup.type) {
      case POPUP_CONSTANTS.SIMPLE_POPUP: {
        return <Popup {...popup} />;
      }
      case POPUP_CONSTANTS.SPINNER_POPUP: {
        return <Spinner name="cube-grid" color="#0045E6" {...popup} />;
      }
      default: {
        console.warn('getPopupContent', popup.type);
        return null;
      }
    }
  };

  render() {
    const viewProps = this.getProps();
    const { popup } = this.state;
    return (
      <>
        {popup ? (
          <PopupContainer> {this.getPopupContent()} </PopupContainer>
        ) : null}
        <ViewRenderer {...viewProps} />
      </>
    );
  }
}

const mapStateToProps = reduxProps => ({
  reduxProps,
});

const mapDispatchToProps = dispatch => ({});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AgencyRefunds),
);